var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectCategoryClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 138",
    d: "M11.2317 1.53666L8.06448 7.87103C8.02373 7.95255 7.94812 8.01112 7.85901 8.03021L1.57117 9.37761C1.33235 9.42878 1.2515 9.72864 1.43222 9.89293L6.3723 14.3839C6.45136 14.4558 6.48623 14.5643 6.46384 14.6688L5.13602 20.8652C5.08243 21.1153 5.34637 21.3135 5.5716 21.1922L11.3578 18.0766C11.4466 18.0288 11.5534 18.0288 11.6422 18.0766L17.4284 21.1922C17.6536 21.3135 17.9176 21.1153 17.864 20.8652L16.5342 14.6596C16.5129 14.5601 16.5434 14.4566 16.6154 14.3846L21.5757 9.42426C21.7505 9.24946 21.6508 8.95011 21.406 8.91515L15.1556 8.02223C15.0582 8.00831 14.9737 7.94746 14.9297 7.85941L11.7683 1.53666C11.6578 1.31554 11.3422 1.31554 11.2317 1.53666Z",
    stroke: "currentColor",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCategoryClosed);
export default __webpack_public_path__ + "static/media/project-category-closed.612212b2.svg";
export { ForwardRef as ReactComponent };